export default __webpack_public_path__ + "static/media/pangolin.517f373a.png";